module.exports = __webpack_public_path__ + "img/tb1041-11-1974.prt.c9fc81b4.jpg";